// ---------------------------------------------------------------------------
// useLoadPersona Hook
// ---------------------------------------------------------------------------
// Handles loading and deleting saved personas (all types: funnel + flat).
// Uses the unified personaService (discovery_personas table).
// Uses useQuery with enabled: false for on-demand fetching (modal open).
// ---------------------------------------------------------------------------

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { personaService } from '@/services/v11/personaService'

const PERSONAS_QUERY_KEY = ['personas'] as const

export function useLoadPersona() {
  const queryClient = useQueryClient()

  const query = useQuery({
    queryKey: PERSONAS_QUERY_KEY,
    queryFn: () => personaService.getAll(),
    enabled: false, // Only fetch when modal opens (manual refetch)
  })

  const deleteMutation = useMutation({
    mutationFn: (id: number) => personaService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PERSONAS_QUERY_KEY })
    },
  })

  return {
    personas: query.data ?? [],
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
    deletePersona: deleteMutation.mutateAsync,
    isDeleting: deleteMutation.isPending,
  }
}
